/* src/app/shared/confirm-modal/confirm-modal.component.scss */
.btns {
  display: grid;
  gap: 12px;
  margin-top: 16px;
}
/*# sourceMappingURL=confirm-modal.component.css.map */
